import { Action } from 'redux'
import actions, { SetSettingsAction } from './actions'
import SettingsState from './SettingsState'

export const actionCreators = {
    setSettings: (settings: SettingsState) => ({ type: actions.SET_SETTINGS, settings } as SetSettingsAction),
    getSettings: () => ({ type: actions.GET_SETTINGS } as Action)
}
